/**
 * Created by agengmaulana on 22/01/18.
 */
import React from 'react'
import Comment_Username from './../comment_username/comment_username'
import {observer} from 'mobx-react';

import styles from './../../assets/css/prokontra_comment.css'

@observer
export default class Prokontra_comment_moderation extends React.Component {

    constructor(props) {
        super(props);

    }
    render(){
        const {dataStore,datastoresVerified} = this.props
        return(
            <div className={styles.dk_pv_komen}>
                { dataStore.moderasi ? <div className={styles.dk_title}>Komentar Anda dalam proses moderasi</div> : <div className={styles.cmt_mt15}></div> }
                <div className={styles.dk_box}>
                    <div className={styles.list_dk}>
    			<span className={styles.ratiobox+' '+styles.dk_box_img}>
					<span className={styles.ratiobox_content+' '+styles.lqd+' '+styles.dk_circle}>
						<img src={dataStore.author.photo} onError={(e)=>{e.target.src="https://connect.detik.com/assets/images/default.png"}} alt={dataStore.author.name} />
					</span>
				</span>
                        <Comment_Username nickname={dataStore.author.name} create_date={dataStore.create_date} mb10="false" verified_user={typeof datastoresVerified[dataStore.author.uniqueid] !== 'undefined'?datastoresVerified[dataStore.author.uniqueid]:false} />
                        <div className={styles.dk_komen}>
                            {unescape(dataStore.content)} </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./static/src/component/prokontra_comment_moderation/prokontra_comment_moderation.js